export var PriceType;
(function (PriceType) {
    /** Unknown price type. This value isn't used. */
    PriceType["UNKNOWN_PRICE_TYPE"] = "UNKNOWN_PRICE_TYPE";
    /** Fee is charged as a fixed monetary amount. */
    PriceType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(PriceType || (PriceType = {}));
export var AppliedAt;
(function (AppliedAt) {
    AppliedAt["UNKNOWN_APPLIED_AT"] = "UNKNOWN_APPLIED_AT";
    /** Fee is added to the first payment. */
    AppliedAt["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AppliedAt || (AppliedAt = {}));
export var Period;
(function (Period) {
    /** Unknown period. This value isn't used. */
    Period["UNKNOWN_PERIOD"] = "UNKNOWN_PERIOD";
    Period["DAY"] = "DAY";
    Period["WEEK"] = "WEEK";
    Period["MONTH"] = "MONTH";
    Period["YEAR"] = "YEAR";
})(Period || (Period = {}));
export var StartType;
(function (StartType) {
    /** Unknown start type. This value isn't used. */
    StartType["UNKNOWN_START_TYPE"] = "UNKNOWN_START_TYPE";
    /** Billing starts immediately after purchase. */
    StartType["ON_PURCHASE"] = "ON_PURCHASE";
    /** Customer can choose when billing starts. */
    StartType["CUSTOM"] = "CUSTOM";
})(StartType || (StartType = {}));
export var EndType;
(function (EndType) {
    /** Unknown end type. This value isn't used. */
    EndType["UNKNOWN_END_TYPE"] = "UNKNOWN_END_TYPE";
    /** Plan continues until customer cancels. */
    EndType["UNTIL_CANCELLED"] = "UNTIL_CANCELLED";
    /** Plan ends after a specified number of billing cycles. */
    EndType["CYCLES_COMPLETED"] = "CYCLES_COMPLETED";
})(EndType || (EndType = {}));
export var Visibility;
(function (Visibility) {
    /** Unknown visibility. This value isn't used. */
    Visibility["UNKNOWN_VISIBILITY"] = "UNKNOWN_VISIBILITY";
    /** Plan is visible and available for purchase by all customers. */
    Visibility["PUBLIC"] = "PUBLIC";
    /** Plan is not visible to new customers, unless they get a specific link to the plan. Existing subscribers can continue using it. */
    Visibility["PRIVATE"] = "PRIVATE";
})(Visibility || (Visibility = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["ACTIVE"] = "ACTIVE";
})(Status || (Status = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["PLAN"] = "PLAN";
    Type["ADD_ON"] = "ADD_ON";
})(Type || (Type = {}));
export var TaxableAddress;
(function (TaxableAddress) {
    TaxableAddress["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    TaxableAddress["BILLING"] = "BILLING";
    TaxableAddress["BUSINESS"] = "BUSINESS";
})(TaxableAddress || (TaxableAddress = {}));
export var ValidationStrategy;
(function (ValidationStrategy) {
    ValidationStrategy["UNKNOWN_VALIDATION_STRATEGY"] = "UNKNOWN_VALIDATION_STRATEGY";
    ValidationStrategy["ON_BEHALF"] = "ON_BEHALF";
    ValidationStrategy["PREVIEW"] = "PREVIEW";
})(ValidationStrategy || (ValidationStrategy = {}));
export var RulesType;
(function (RulesType) {
    RulesType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    RulesType["AVAILABLE_IMMEDIATELY"] = "AVAILABLE_IMMEDIATELY";
    RulesType["FIXED_DATES"] = "FIXED_DATES";
    RulesType["RECURRENCE"] = "RECURRENCE";
})(RulesType || (RulesType = {}));
export var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["UNKNOWN_RECURRENCE_TYPE"] = "UNKNOWN_RECURRENCE_TYPE";
    RecurrenceType["WEEKLY"] = "WEEKLY";
    RecurrenceType["MONTHLY"] = "MONTHLY";
})(RecurrenceType || (RecurrenceType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["UNKNOWN_DAY_OF_WEEK"] = "UNKNOWN_DAY_OF_WEEK";
    DayOfWeek["SUNDAY"] = "SUNDAY";
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
})(DayOfWeek || (DayOfWeek = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var Cascade;
(function (Cascade) {
    /** Change the price for the plan only, without affecting existing subscriptions. */
    Cascade["NEW_SUBSCRIPTIONS"] = "NEW_SUBSCRIPTIONS";
    /** Change the price for the plan and apply it to existing subscriptions. */
    Cascade["ALL_SUBSCRIPTIONS"] = "ALL_SUBSCRIPTIONS";
})(Cascade || (Cascade = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Should sort by number of matches */
    SortType["COUNT"] = "COUNT";
    /** Should sort by value of the field alphabetically */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Should sort in descending order */
    SortDirection["DESC"] = "DESC";
    /** Should sort in ascending order */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Should missing values be excluded from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Should missing values be included in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value */
    ScalarType["MIN"] = "MIN";
    /** Maximum value */
    ScalarType["MAX"] = "MAX";
    /** Sum of values */
    ScalarType["SUM"] = "SUM";
    /** Average of values */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval */
    Interval["YEAR"] = "YEAR";
    /** Monthly interval */
    Interval["MONTH"] = "MONTH";
    /** Weekly interval */
    Interval["WEEK"] = "WEEK";
    /** Daily interval */
    Interval["DAY"] = "DAY";
    /** Hourly interval */
    Interval["HOUR"] = "HOUR";
    /** Minute interval */
    Interval["MINUTE"] = "MINUTE";
    /** Second interval */
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within previous one */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
//# sourceMappingURL=types.impl.js.map